export default __webpack_public_path__ + "static/media/lift.inline.24afd22f.svg";